import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

type Props = {
  name: string;
  id: string;
  isChecked: boolean;
  onChange: Function;
  value: string;
};

export const RadioBox = ({ ...props }: Props) => {
  return (
    <Styled isChecked={props.isChecked}>
      <input
        type="radio"
        name={props.name}
        id={props.id}
        value={props.value}
        defaultChecked={props.isChecked}
        onChange={() => {
          props.onChange(props.value);
        }}
      />
      <span>{props.value}</span>
    </Styled>
  );
};

type StyledProps = {
  isChecked: boolean;
};

const Styled = styled.label<StyledProps>`
  display: flex;
  align-items: center;
  > input {
    width: 28px;
    height: 28px;
    background: #fff;
    border-radius: 50%;
    position: relative;
    appearance: none;
    &:after {
      content: '';
      display: ${({ isChecked }) => (isChecked ? 'block' : 'none')};
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: ${StyleConfig.COLOR.PRIMARY};
      border-radius: 50%;
      width: 50%;
      height: 50%;
      margin: auto;
    }
  }
  > span {
    margin-left: ${StyleConfig.HELPER.M4};
  }
`;

export default RadioBox;
